import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../auth/actionAuth";
import { actionSubscriptionInfoUpdate } from "./actionSubscriptionInfo";
export var epicSubscriptionInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionAuth.Login), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.SubscriptionInfo,
            props: {
                playerId: action.playerId,
            },
        });
    }), retry(), map(function (res) { return actionSubscriptionInfoUpdate(res); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/subscription/epicSubscriptionInfo.ts
// module id = 1973
// module chunks = 3